window.SwalConfirmButtonColor = "var(--primary)";
window.SwalCancelButtonColor = "var(--secondary)";